import React from 'react';
import { createView, view } from '@sail/ui';
import { helmTokens } from '../../theme';
export const QuestionMarks = createView((props)=>{
    return /*#__PURE__*/ React.createElement(view.svg, {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement(view.path, {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 0C24.0081 0 30.5 6.49187 30.5 14.5C30.5 22.5081 24.0081 29 16 29C7.99187 29 1.5 22.5081 1.5 14.5C1.5 6.49187 7.99187 0 16 0ZM16.0031 18.4034C15.0718 18.4034 14.3168 19.2085 14.3168 20.2017C14.3168 21.1949 15.0718 22 16.0031 22C16.9345 22 17.6895 21.1949 17.6895 20.2017C17.6895 19.2085 16.9345 18.4034 16.0031 18.4034ZM12.7908 8.29687C11.9078 9.21556 11.4396 10.496 11.5063 11.8096H14.1594C14.1594 10.0713 15.0813 9.33997 16.0369 9.33997C16.4483 9.26733 16.8679 9.40456 17.1705 9.7107C17.473 10.0168 17.6235 10.4565 17.577 10.8985C17.577 12.0494 17.4084 12.2652 16.4191 13.0804C15.2881 13.8403 14.6172 15.1802 14.6541 16.6051H17.1274C17.2711 15.7175 17.7779 14.9441 18.5101 14.4951C19.7178 13.8214 20.4818 12.4957 20.5 11.0424C20.5 9.65168 19.5444 7.01417 16.1156 7.01417C14.8857 6.91062 13.6738 7.37818 12.7908 8.29687Z",
        css: {
            fill: `${helmTokens.color.blendBackground}`
        }
    }), /*#__PURE__*/ React.createElement(view.path, {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33.9625 26.9915C36.1094 25.8237 37.4677 23.5259 37.5 21.0068C37.5 18.5962 35.8012 14.0246 29.7054 14.0246C27.5191 13.8451 25.3646 14.6555 23.7948 16.2479C22.2249 17.8403 21.3926 20.0597 21.5111 22.3367H26.2279C26.2279 19.3236 27.8667 18.056 29.5655 18.056C30.297 17.93 31.043 18.1679 31.5808 18.6986C32.1187 19.2292 32.3862 19.9913 32.3036 20.7574C32.3036 22.7523 32.0038 23.1264 30.2451 24.5394C28.2345 25.8565 27.0416 28.179 27.1072 30.6488H31.5042C31.7597 29.1103 32.6607 27.7698 33.9625 26.9915ZM29.5056 40C31.1613 40 32.5035 38.6044 32.5035 36.8829C32.5035 35.1614 31.1613 33.7659 29.5056 33.7659C27.8499 33.7659 26.5077 35.1614 26.5077 36.8829C26.5077 38.6044 27.8499 40 29.5056 40Z",
        css: {
            fill: `${helmTokens.color.blendForeground}`
        }
    }), /*#__PURE__*/ React.createElement(view.path, {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.7948 16.2479C25.3646 14.6555 27.5191 13.8451 29.7054 14.0246C29.9769 14.0246 30.2396 14.0336 30.4938 14.0512C30.4977 14.2 30.5 14.3497 30.5 14.5C30.5 15.7164 30.3502 16.8978 30.0681 18.0269C29.9012 18.0174 29.733 18.0271 29.5655 18.056C27.8667 18.056 26.2279 19.3236 26.2279 22.3367H21.5111C21.3926 20.0597 22.2249 17.8403 23.7948 16.2479Z",
        css: {
            fill: `${helmTokens.color.blendIntersection}`
        }
    }));
});

//# sourceMappingURL=QuestionMarks.js.map